define.alias("checkout/components/charges-summary", "calendar/components/charges-summary");